import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tipoPrioridadService = {
  getAll,
}

async function getAll() {
  return await ApiBudgety.get('TipoPrioridad/GetAll/')
}
